import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmationDialogComponent } from './confirmation-dialog.component';
import { ConfirmationDialogService } from './confirmation-dialog.service';

@NgModule({
    declarations: [
        ConfirmationDialogComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        ConfirmationDialogComponent
    ],
    providers: [
        ConfirmationDialogService
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ConfirmationDialogModule { } 